import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ElevatorCTA = () => {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Decorative vertical divider background */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none">
        <div className="flex justify-around h-full">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="w-px h-full bg-[#4D4C4A]"></div>
          ))}
        </div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="border-2 border-[#91756A]/20 p-12 md:p-20 relative bg-white shadow-sm"
          >
            {/* Corner accents */}
            <div className="absolute -top-1 -left-1 w-12 h-12 border-t-4 border-l-4 border-[#91756A]"></div>
            <div className="absolute -bottom-1 -right-1 w-12 h-12 border-b-4 border-r-4 border-[#91756A]"></div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 0.8 }}
            >
              <h2 className="text-sm font-bold uppercase tracking-[0.4em] text-[#91756A] mb-8">Start Your Elevator Project</h2>
              <h3 className="text-4xl md:text-5xl font-bold text-[#4D4C4A] italic tracking-tighter uppercase mb-10 leading-tight">
                Engineering <br /> 
                <span className="text-[#91756A]">Reliability</span> <br /> 
                for Every Level.
              </h3>
              
              <p className="text-slate-500 text-lg md:text-xl leading-relaxed mb-12 max-w-2xl mx-auto italic font-light">
                Our team is ready to support your next development with reliable and efficient vertical transportation 
                systems, from system design to installation and long-term maintenance.
              </p>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.4, duration: 0.8 }}
                className="flex flex-col sm:flex-row justify-center gap-6"
              >
                <Link to="/contact-consultation">
                  <Button 
                    variant="default" 
                    className="bg-[#4D4C4A] hover:bg-[#3d3c3a] text-white px-12 py-8 rounded-none text-sm font-bold uppercase tracking-[0.3em] h-auto group transition-all duration-500 hover:scale-105"
                  >
                    Discuss Requirements
                    <Icon name="ArrowRight" size={16} className="ml-3 group-hover:translate-x-2 transition-transform duration-300" />
                  </Button>
                </Link>
                <Link to="/project-portfolio">
                  <Button 
                    variant="outline" 
                    className="border-[#4D4C4A] text-[#4D4C4A] hover:bg-slate-50 px-12 py-8 rounded-none text-sm font-bold uppercase tracking-[0.3em] h-auto border-2"
                  >
                    View Portfolio
                  </Button>
                </Link>
              </motion.div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ElevatorCTA;